import sCiv from "@assets/models/ship/sCiv.glb";
import mCiv from "@assets/models/ship/m_civ.glb";
import mMinExample from "@assets/models/ship/m_min_example.glb";
import axe from "@assets/models/ship/m_mil_axe.glb";
import dart from "@assets/models/ship/dart.glb";
import marble from "@assets/models/ship/marble.glb";
import facility from "@assets/models/facility.glb";
import gateway from "@assets/models/gateway.glb";
import lMil from "@assets/models/ship/lMil.glb";
import asteroid1 from "@assets/models/world/asteroid_1.glb";
import asteroid2 from "@assets/models/world/asteroid_2.glb";
import asteroid3 from "@assets/models/world/asteroid_3.glb";
import asteroid4 from "@assets/models/world/asteroid_4.glb";
import asteroid5 from "@assets/models/world/asteroid_5.glb";
import asteroid6 from "@assets/models/world/asteroid_6.glb";
import asteroidSmall1 from "@assets/models/world/asteroid_small_1.glb";
import asteroidSmall2 from "@assets/models/world/asteroid_small_2.glb";
import asteroidSmall3 from "@assets/models/world/asteroid_small_3.glb";
import asteroidSmall4 from "@assets/models/world/asteroid_small_4.glb";
import planet from "@assets/models/world/planet.glb";

export default {
  "ship/sCiv": sCiv,
  "ship/mCiv": mCiv,
  "ship/mMinExample": mMinExample,
  "ship/marble": marble,
  "ship/lMil": lMil,
  "ship/dart": dart,
  "ship/axe": axe,
  "facility/default": facility,
  "facility/gateway": gateway,
  "world/asteroid1": {
    model: asteroid1,
    material: "asteroidNew",
  },
  "world/asteroid2": {
    model: asteroid2,
    material: "asteroidNew",
  },
  "world/asteroid3": {
    model: asteroid3,
    material: "asteroidNew",
  },
  "world/asteroid4": {
    model: asteroid4,
    material: "asteroidNew",
  },
  "world/asteroid5": {
    model: asteroid5,
    material: "asteroidNew",
  },
  "world/asteroid6": {
    model: asteroid6,
    material: "asteroidNew",
  },
  "world/asteroidSmall1": {
    model: asteroidSmall1,
    material: "asteroidRock",
  },
  "world/asteroidSmall2": {
    model: asteroidSmall2,
    material: "asteroidRock",
  },
  "world/asteroidSmall3": {
    model: asteroidSmall3,
    material: "asteroidRock",
  },
  "world/asteroidSmall4": {
    model: asteroidSmall4,
    material: "asteroidRock",
  },
  "world/planet": planet,
};
